import { DB } from '@21st-night/utils';

export function completeOnboarding(db: DB, userId: string): Promise<void> {
  return db.collection('users').doc(userId).update({
    'onboarding.completed': true,
  });
}
